export const nav = {
    p1: `Hier verwalten Sie Ihre persönlichen Daten, ändern Ihr Passwort, Ihre Integrationen und Ihr Abonnement und passen Ihre Benutzereinstellungen an`,
    p2: `Mein Konto`,
    p3: `Passen Sie die Angaben zu Ihrer Unterkunft, Willkommensnachrichten und Richtlinien an, verbinden Sie sich mit den Behörden für die automatische Übermittlung der Gästemeldungen und stellen Sie Ihre Betriebseinstellungen ein`,
    p4: `Unterkunftseinstellungen`,
    p5: `Verwalten und bewerben Sie die Zusatzleistungen Ihrer Unterkunft, etwa Raumvermietungen, Touren und weitere Extras, um das Erlebnis Ihrer Gäste zu verbessern und Ihren Umsatz zu steigern`,
    p6: `Cross-Selling`,
    p7: `Neue Unterkunft anlegen`,
    p8: `Bestätigungs-E-Mail erfolgreich gesendet`,
    p9: `Unterkünfte`,
    p10: ``,
    p11: ``,
    p12: ``,
    p13: ``,
    p14: ``,
    p15: ``,
    p16: ``,
    p17: ``,
    p18: ``,
    p19: ``,
    p20: ``,
    p21: ``,
    p22: ``,
    p23: ``,
};
